import { v4 as uuid } from 'uuid';

interface EventBusSubscriber {
    id: string;
    eventType: unknown;
    callback: Function;
}

export class EventBusBase {
    private observers: EventBusSubscriber[] = [];
    public observe(eventType: unknown, callback: Function): string {
        const id = uuid();
        this.observers.push({
            eventType: eventType,
            callback: callback,
            id: id
        });
        return id;
    }

    public emit(eventType: unknown, data?: unknown): void {
        this.observers.filter(elem => elem.eventType === eventType).forEach(elem => elem.callback(data));
    }

    public deleteObserver(ids: string | string[]): void {
        this.observers = Array.isArray(ids)
            ? this.observers.filter(elem => ids.indexOf(elem.id) === -1)
            : this.observers.filter(elem => elem.id !== ids);
    }
}

export const EventBus = new EventBusBase();
